import { Component, Input, OnInit } from '@angular/core';
import { ModalController, LoadingController } from '@ionic/angular';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  standalone: false,
  selector: 'app-logout-confirmation-modal',
  templateUrl: './logout-confirmation-modal.component.html',
  styleUrls: ['./logout-confirmation-modal.component.scss'],
  animations: [
    trigger('slideInUp', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ]),
    trigger('fadeInScale', [
      transition(':enter', [
        style({ transform: 'scale(0.8)', opacity: 0 }),
        animate('250ms ease-out', style({ transform: 'scale(1)', opacity: 1 }))
      ])
    ])
  ]
})
export class LogoutConfirmationModalComponent implements OnInit {
  @Input() userProfile: any = null;
  @Input() hasUnsavedChanges: boolean = false;

  isLoggingOut = false;
  userName = '';
  userEmail = '';

  constructor(
    private modalController: ModalController,
    private loadingController: LoadingController
  ) {}

  ngOnInit() {
    this.initializeUserInfo();
  }

  private initializeUserInfo() {
    if (this.userProfile) {
      this.userName = this.userProfile.firstName || this.userProfile.name || 'User';
      this.userEmail = this.userProfile.emailId || this.userProfile.email || '';
    }
  }

  async confirmLogout() {
    this.isLoggingOut = true;

    // Show loading state
    const loading = await this.loadingController.create({
      message: 'Signing out securely...',
      spinner: 'crescent',
      duration: 1500
    });

    await loading.present();

    // Simulate logout process delay for better UX
    setTimeout(async () => {
      await loading.dismiss();
      this.modalController.dismiss({ confirmed: true });
    }, 1500);
  }

  async cancelLogout() {
    this.modalController.dismiss({ confirmed: false });
  }

  async saveAndLogout() {
    this.isLoggingOut = true;

    const loading = await this.loadingController.create({
      message: 'Saving and signing out...',
      spinner: 'crescent',
      duration: 2000
    });

    await loading.present();

    setTimeout(async () => {
      await loading.dismiss();
      this.modalController.dismiss({ confirmed: true, saveFirst: true });
    }, 2000);
  }

  getLogoutMessage(): string {
    if (this.hasUnsavedChanges) {
      return 'You have unsaved changes that will be lost if you sign out now.';
    }
    return 'You\'ll need to sign in again to access your forms and data.';
  }

  getTimeEstimate(): string {
    return 'Signing back in typically takes less than 30 seconds.';
  }
}